import React from 'react';
import './App.css';

import Routes from './components/Routes'

export default function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}